import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useCompetencyStore = defineStore('competency-framework', () => {
  //////////// State ////////////
  const selectedUuid = ref<string>();
  const developmentPlanOption = ref<boolean>();

  return {
    selectedUuid,
    developmentPlanOption,
  };
});
